// ----------------------------------------------------------------------------
// Snippet: Mini Cart
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------


// -------------------------------------
// Dependencies
// -------------------------------------

// Scripts
import { cartSubtotalUpdate } from 'snippets/cart-js/ajax-add-cart';
import 'snippets/cart-js/cart-js';
import 'snippets/card/card';

// Styles
import './_mini-cart.scss';

const MINI_CART_ITEM_DROPDOWN = '.mini-cart__item--dropdown';
const MINI_CART_LINK = '.mini-cart__header-link';


document.addEventListener("DOMContentLoaded", function() {
    Shopify.miniCart = (function() {

        const _config = {
            menuLinkCart: '.menu__link-cart',
            shopifyAjaxCartURL: '/cart.js',
        };

        const _init = function() {
            const menuLinkCart = document.querySelector(_config.menuLinkCart);

            if (menuLinkCart) {
                // Update cart count
                const xhr = new XMLHttpRequest();
                xhr.open('GET', _config.shopifyAjaxCartURL);
                xhr.onload = function() {
                    if (xhr.status === 200) {
                        const cart = JSON.parse(xhr.responseText);

                        // Update cart subtotal and items
                        cartSubtotalUpdate(cart);
                    }
                };
                xhr.send();
            }
        }

        return {
            init: function(params) {
                // Configuration
                params = params || {};
                // Merging with defaults
                Object.assign(_config, params);
                // Action
                _init();
            },
            getConfig: function() {
                return _config;
            }
        };
    })();

    Shopify.miniCart.init();
});


document.addEventListener('DOMContentLoaded', () => {

    const miniCartItemDropdown = document.querySelector(MINI_CART_ITEM_DROPDOWN);
    const miniCartLink = document.querySelector(MINI_CART_LINK);

    miniCartItemDropdown?.addEventListener('focusin', () => {
        if (!miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartItemDropdown.classList.add('js--is-open');
            const tabIndexItems = miniCartItemDropdown.querySelectorAll('[tabindex="-1"]');
            tabIndexItems.forEach((tabIndexItem) => {
                tabIndexItem.setAttribute('tabindex', '0');
            });
        }
    });

    miniCartItemDropdown?.addEventListener('focusout', () => {
        if (miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartItemDropdown.classList.remove('js--is-open');
        }
    });

    miniCartItemDropdown?.addEventListener('keyup', (e) => {
        if (e.key === 'Escape' && miniCartItemDropdown.classList.contains('js--is-open')) {
            miniCartLink.focus();
            miniCartItemDropdown.classList.remove('js--is-open');
        }
    });
});


